export const ONE_KEY_DELETE_NONCE = "__ONE_KEY_DELETE_NONCE__";
export const ONE_KEY_NAMESPACE = "noncev2";
